import { newsTypes } from './actionTypes'
import {
    INews,
    SetNews,
    FetchNewsPayload,
    FetchNewsRequest,
    FetchOnePieceOfNewsPayload,
    FetchNewsByIdRequest,
    CreateNewsPayload,
    CreateNewsRequest,
    EditNewsPayload,
    EditNewsRequest,
    DeleteNewsPayload,
    DeleteNewsRequest,
    SetArticle,
} from './types'

export const fetchNewsAction = (
    payload: FetchNewsPayload,
): FetchNewsRequest => ({
    type: newsTypes.FETCH_NEWS_REQUEST,
    payload,
})

export const fetchOnePieceOfNewsAction = (
    payload: FetchOnePieceOfNewsPayload,
): FetchNewsByIdRequest => ({
    type: newsTypes.FETCH_NEWS_BY_ID,
    payload,
})

export const createNewsAction = (
    payload: CreateNewsPayload,
): CreateNewsRequest => ({
    type: newsTypes.CREATE_NEWS_REQUEST,
    payload,
})

export const editNewsAction = (payload: EditNewsPayload): EditNewsRequest => ({
    type: newsTypes.EDIT_NEWS_REQUEST,
    payload,
})

export const deleteNewsAction = (
    payload: DeleteNewsPayload,
): DeleteNewsRequest => ({
    type: newsTypes.DELETE_NEWS_REQUEST,
    payload,
})

export const SetNewsAction = (payload: {
    news: INews[] | undefined
}): SetNews => ({
    type: newsTypes.SET_NEWS,
    payload,
})

export const SetArticleAction = (payload: { article: INews }): SetArticle => ({
    type: newsTypes.SET_ONE_PIECE_OF_NEWS,
    payload,
})
